export default __webpack_public_path__ + "static/media/2_0134.a37326b9.webp";